import { Flex } from 'components/flex';
import { ReactNode, SelectHTMLAttributes } from 'react';

import styled, { ColorsTypes } from 'styled-components';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode;
  borderColor?: ColorsTypes;
}

const Select = styled('select')`
  border: 2px solid ${(props: any) => props.theme.colors[props['data-bordercolor']]};
  border-radius: 4px;
  padding: 10px 40px 10px 20px;
  outline: none;
  width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  position: relative;
  color: ${({ theme }) => theme.colors.gray_500};

  &::-ms-expand {
    display: none;
  }

  ${({ theme }) => theme.fontTypes.type3}

  option {
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`;

const Arrow = styled('i')`
  border-top: 7px solid ${({ theme }) => theme.colors.primary_200};
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  right: 20px;
  pointer-events: none;
`;

const Wrapper = styled(Flex)`
  position: relative;
  width: 100%;
`;

const Teste = ({ children, borderColor = 'gray_200', ...props }: SelectProps) => (
  <Wrapper>
    <Arrow />

    <Select data-bordercolor={borderColor} {...props}>
      {children}
    </Select>
  </Wrapper>
);

export default Teste;
